var map = {
	"./accent/calendar.svg": 80592,
	"./accent/journal.svg": 81859,
	"./accent/layouts.svg": 79819,
	"./accent/tasks.svg": 66784,
	"./ai-assistant.svg": 21796,
	"./ai-stars-x3.svg": 43899,
	"./arrow.svg": 25412,
	"./auth-background.png": 42783,
	"./calendar-active.svg": 16062,
	"./calendar-inactive.svg": 1683,
	"./calendar.svg": 68559,
	"./classroom-active.svg": 2193,
	"./classroom.png": 8109,
	"./classroom.svg": 58290,
	"./community-active.png": 64420,
	"./community-active.svg": 92483,
	"./community-inactive.svg": 2378,
	"./community.png": 56527,
	"./community.svg": 84384,
	"./dark-grey/arrow-down.svg": 46018,
	"./dark-grey/calendar.svg": 59260,
	"./dark-grey/filter.svg": 48756,
	"./empty-search.svg": 87969,
	"./empty-tasks.svg": 91673,
	"./empty.svg": 52,
	"./error-broccoli.svg": 90287,
	"./fall.svg": 27138,
	"./gift.png": 90996,
	"./hard-snow.svg": 38598,
	"./inventory.svg": 84163,
	"./journal-active.svg": 76281,
	"./journal-inactive.svg": 26636,
	"./journal.svg": 48650,
	"./layouts.svg": 67622,
	"./logo-text-1.png": 61233,
	"./logo.svg": 13208,
	"./logotext.svg": 28269,
	"./mild-grey/arrow-down.svg": 32556,
	"./no-cover.svg": 22358,
	"./one-cover.svg": 20033,
	"./pencil.svg": 77514,
	"./plus.svg": 32601,
	"./primary/add.svg": 2633,
	"./records.svg": 97141,
	"./right-arrow.svg": 81125,
	"./search.svg": 95797,
	"./secondary/close.svg": 17304,
	"./snow.svg": 79940,
	"./spring.svg": 54298,
	"./store.svg": 44608,
	"./taskIcons/bed-preparation.svg": 99900,
	"./taskIcons/cultivating.svg": 32935,
	"./taskIcons/custom-task.svg": 6616,
	"./taskIcons/harvesting.svg": 87146,
	"./taskIcons/seeding.svg": 66604,
	"./taskIcons/transplanting.svg": 76398,
	"./tasks-active.svg": 52760,
	"./tasks-inactive.svg": 31441,
	"./tasks.svg": 24354,
	"./tasks16/bed-preparation.svg": 29904,
	"./tasks16/cultivating.svg": 69595,
	"./tasks16/custom-task.svg": 87092,
	"./tasks16/harvesting.svg": 34998,
	"./tasks16/seeding.svg": 4640,
	"./tasks16/transplanting.svg": 29618,
	"./tasks16/white/bed-preparation.svg": 22362,
	"./tasks16/white/cultivating.svg": 84137,
	"./tasks16/white/custom-task.svg": 55422,
	"./tasks16/white/harvesting.svg": 12700,
	"./tasks16/white/seeding.svg": 22842,
	"./tasks16/white/transplanting.svg": 41968,
	"./two-covers.svg": 35454,
	"./undo.svg": 82027,
	"./user.svg": 24948,
	"./variety-info/average-yield.svg": 1472,
	"./variety-info/crop-families.svg": 37962,
	"./variety-info/days-to-maturity.svg": 21148,
	"./variety-info/depth.svg": 7634,
	"./variety-info/frost-kill.svg": 7724,
	"./variety-info/frost-tolerance.svg": 80305,
	"./variety-info/germination-temp.svg": 4479,
	"./variety-info/heat-tolerance.svg": 75747,
	"./variety-info/ideal-growing-temp.svg": 35477,
	"./variety-info/prefered-ph.svg": 90511,
	"./variety-info/season.svg": 52524,
	"./variety-info/seeds.svg": 32979,
	"./variety-info/spacing.svg": 10302,
	"./variety-info/storage-humidity.svg": 96944,
	"./variety-info/storage-temp.svg": 96005,
	"./variety-info/sun.svg": 94943,
	"./white/add.svg": 1084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8257;